import { useState, useCallback } from 'react'
import { CustomSelectWithSearchBarNotInFilteredItems } from '../../../../../../forms/CustomSelect'
import { CustomChangeFunction } from '../../../../../../forms/Input/types'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { changeEmployeeParams } from '../../../../../../utils/reducers/reduxDispatch'
import { VerticalSortListDelete } from '../../../../../Sorts/VerticalSortList'
import { VerticalSortItem } from '../../../../../Sorts/VerticalSortList/types'
import { MediumModalCreateEdit } from '../../../../../ModalsLayouts/ModalCreateEdit'
import { BeforeSubmitHandler } from '../../../../../../forms/TwinForm/types'
import { ModalEditComponentPropsWithoutSubmit } from '../../../../../ModalsLayouts/types'

type ModalQuickCreateToolsConfigProps = ModalQuickCreateToolsConfigLogicProps & ModalEditComponentPropsWithoutSubmit & { }

const ModalQuickCreateToolsConfig: React.FC<ModalQuickCreateToolsConfigProps> = ({ myCreateToolsItems, myActiveCreateToolsItems, setOpened }) => {
    const { t } = useTwinTranslation()
    const { mySelectedCreateTools, onSubmitHandler, excludeIds, changeData, setMySelectedCreateTools, beforeSubmit } = useModalQuickCreateToolsConfigLogic({ myActiveCreateToolsItems, myCreateToolsItems })
    return (
        <MediumModalCreateEdit setOpened={setOpened} beforeSubmit={beforeSubmit} className='notFlexAutoFormRender' onSubmit={onSubmitHandler} fields={[]} translations={{
            title: t('configQuickCreateTools','Configura tus accesos de creación rápida'),
            button: t('save','Guardar')
        }} haveButtonPermissions={true} url={'/api/app/config/employee/updateEmployeeParameter'}>
            <CustomSelectWithSearchBarNotInFilteredItems excludeItems={excludeIds || []} items={myCreateToolsItems} fieldName='title' onChange={changeData} label={t('searchQuickCreateTools', 'Buscar accesos de creación rápida...')} className='mb-5' sortItems={true} />
            <div className='flex-auto table_container mt-20'>
                <VerticalSortListDelete items={mySelectedCreateTools || []} setItems={setMySelectedCreateTools} />
            </div>
        </MediumModalCreateEdit>
    )
}

interface ModalQuickCreateToolsConfigLogicProps {
    myActiveCreateToolsItems: VerticalSortItem[]
    myCreateToolsItems: TwinDictionary
}

const useModalQuickCreateToolsConfigLogic = ({ myActiveCreateToolsItems, myCreateToolsItems }: ModalQuickCreateToolsConfigLogicProps) => {
    const [mySelectedCreateTools, setMySelectedCreateTools] = useState<VerticalSortItem[] | null>(myActiveCreateToolsItems || [])
    let excludeIds: string[] = []
    if (mySelectedCreateTools) {
        for (const element of mySelectedCreateTools) {
            excludeIds.push(element.id)
        }
    }

    const beforeSubmit: BeforeSubmitHandler = useCallback((vals) => {
        vals.parameterKey = 'quickCreateTools'
        vals.value = JSON.stringify(mySelectedCreateTools || [])
        return true
    }, [mySelectedCreateTools])

    const changeData: CustomChangeFunction = useCallback((value) => {
        const item = myCreateToolsItems[value]
        setMySelectedCreateTools((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            copy.push({
                id: item?.id,
                name: item?.title,
                order: (old?.length || 0) + 1
            })
            return [...copy]
        })
    }, [setMySelectedCreateTools, myCreateToolsItems])

    const onSubmitHandler = useCallback(async () => {
        const myValuesStr = JSON.stringify(mySelectedCreateTools || [])
        changeEmployeeParams({ 'quickCreateTools': myValuesStr })
        return 
    }, [mySelectedCreateTools])

    return { onSubmitHandler, mySelectedCreateTools, excludeIds, changeData, setMySelectedCreateTools, beforeSubmit }
}

export default ModalQuickCreateToolsConfig